const normalizeServiceCode = (service) => {
  if (!service) return '';
  return String(service.code || '').trim().toLowerCase();
};

const shouldSharePolicyInputs = ({
  service,
  allSelectedServices = [],
  isSingleton = true,
}) => {
  if (!service || !Array.isArray(allSelectedServices)) return false;

  const currentCode = normalizeServiceCode(service);
  const hasKvg = allSelectedServices.some((candidate) => normalizeServiceCode(candidate) === 'kvg');
  const vvgServices = allSelectedServices.filter((candidate) => normalizeServiceCode(candidate) === 'vvg');

  if (currentCode === 'kvg') {
    return hasKvg && hasVvgServices(vvgServices) && isSingleton;
  }

  if (currentCode === 'vvg') {
    if (hasKvg) {
      return true;
    }

    return vvgServices.length > 1 && isSingleton;
  }

  return false;
};

const hasVvgServices = (services = []) => services.length > 0;

const getSharedPolicyInputOwner = ({
  service,
  allSelectedServices = [],
  serviceSelectionOrder = [],
}) => {
  if (!service || !Array.isArray(allSelectedServices)) return false;

  const currentCode = normalizeServiceCode(service);
  const kvgSelected = allSelectedServices.some((candidate) => normalizeServiceCode(candidate) === 'kvg');
  const vvgSelected = allSelectedServices.filter((candidate) => normalizeServiceCode(candidate) === 'vvg');

  if (currentCode === 'kvg') {
    return kvgSelected && vvgSelected.length > 0;
  }

  if (currentCode === 'vvg') {
    if (kvgSelected) {
      return false;
    }

    if (vvgSelected.length <= 1) {
      return true;
    }

    const selectedVvgIds = vvgSelected.map((candidate) => candidate.id);
    const firstSelectedId = serviceSelectionOrder.find((id) => selectedVvgIds.includes(id)) || selectedVvgIds[0];
    return service.id === firstSelectedId;
  }

  return true;
};

module.exports = {
  normalizeServiceCode,
  shouldSharePolicyInputs,
  getSharedPolicyInputOwner,
};